import AddonsSelector from './AddonsSelector';
import { ADDON_LIST, getAddonPrices } from './addons';
import { usePricing } from './usePricing';
import AvailabilityCalendar from './AvailabilityCalendar';
import React, { useState } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#3AAF58', blue:'#FFFFFF',
 red:'#E05050', redBg:'rgba(224,80,80,.10)', redBorder:'rgba(224,80,80,.25)',
 amber:'#D4840F', amberBg:'rgba(212,132,15,.10)', amberBorder:'rgba(212,132,15,.25)',
 green:'#3AAF58', greenBg:'rgba(58,175,88,.10)', greenBorder:'rgba(58,175,88,.25)',
 purple:'#8060C0', purpleBg:'rgba(128,96,192,.10)',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});

const BASE_RATES = {
 room_with_breakfast: 7499,
 extra_person: 2500,
 lunch: 2150,
 hi_tea: 950,
 dinner: 3500,
 gala_dinner: 4500,
 breakfast_standalone: 850,
 venue_rent: 500000,
};

// ADDON_LIST imported from addons.js


const MENU = {
 lunch: { label:' Lunch', rate:BASE_RATES.lunch,
 categories:[
 {name:'Main Course',items:['Paneer Butter Masala','Palak Corn','Mix Veg','Dum Aloo Banarasi','Rajma Masala','Kadhi Pakora','Mutter Mushroom','Veg Kofta Curry','Navratan Korma']},
 {name:'Dal',items:['Dal Makhani','Dal Tadka','Dal Bukhara']},
 {name:'Rice & Bread',items:['Jeera Rice','Peas Pulao','Roti','Naan','Paratha','Missi Roti']},
 {name:'Salad & Condiments',items:['Fresh Salad','Raita','Achar','Papad']},
 {name:'Desserts',items:['Hot Gulab Jamun','Ice Cream','Jalebi Rabri','Assorted Ice Cream']},
 ]},
 hi_tea: { label:' Hi-Tea', rate:BASE_RATES.hi_tea,
 categories:[
 {name:'Beverages',items:['Tea','Coffee']},
 {name:'Snacks',items:['Assorted Pakoras','Cookies','Veg Cutlet','Cocktail Samosa','Veg Sandwich']},
 ]},
 dinner: { label:' Dinner', rate:BASE_RATES.dinner,
 categories:[
 {name:'Beverages',items:['Assorted Aerated Drinks','Mineral Water','Tea/Coffee','Soft Drinks (4 Types)','Mocktails (4 Types)']},
 {name:'Soups (Any 1)',items:['Cream of Tomato','Hot and Sour','Lemon Coriander']},
 {name:'Veg Snacks (Any 4)',items:['Paneer Tikka','Mushroom Tikka','Spring Rolls','Honey Chilli Potato','Thai Spring Roll','Zafrani Malai Chaap','Dry Manchurian','Chilly Paneer','Cheese Balls','Corn Kebab']},
 {name:'Non-Veg Snacks (Any 4)',items:['Murg Malai Tikka','Chicken Seekh Kebab','Chicken Tikka','Galouti Kebab','Chilli Chicken','Chicken Lollipop','Fish Fingers']},
 {name:'Main Course Veg (Any 6)',items:['Dal Makhni','Shahi Paneer','Paneer Pasanda','Kadai Paneer','Veg Jalfrezi','Mushroom Do Pyaza','Baingan Bharta','Aloo Gobi Masala','Pindi Chana','Amritsari Chole','Hakka Noodles']},
 {name:'Main Course Non-Veg (Any 2)',items:['Butter Chicken','Murg Lababdar','Mutton Roganjosh','Laal Maas','Mutton Korma','Goan Fish Curry']},
 {name:'Purani Dilli Ke Khomche (Any 4)',items:['Golgappe (4 Types)','Bhalla Papdi','Moong Dal Chilla','Aloo Paneer Corn Tikki','Pav Bhaji']},
 {name:'Desserts (Any 3)',items:['Gulab Jamun','Moong Dal Halwa','Gajar Halwa','Sponge Rasgulla','Ice Cream with Hot Chocolate']},
 {name:'Breads',items:['Roti','Naan','Lacha Paratha','Missi Roti']},
 {name:'Rice (Any 2)',items:['Veg Biryani','Zeera Rice','Peas Pulao','Plain Rice']},
 ]},
 gala_dinner:{ label:' Gala Dinner', rate:BASE_RATES.gala_dinner,
 categories:[
 {name:'Welcome Drinks',items:['Mocktail Mojito','Virgin Mango Mint','Lavender Welcome Drink','Apple Cider','Satvik Jal Jeera','Chocolate Shake','Strawberry Shake','Soft Drinks','Assorted Juices']},
 {name:'Chaat from Dilli 6 (Any 5)',items:['Golgappe (Atta & Suji)','Dahi Gujia','Papri Chaat','Aloo ki Karari Tikki','Matara Kulcha','Moong Dal Chilla','Mumbai Pav Bhaji','Ram Laddoo','Roadside Chowmein']},
 {name:'Snacks Tray Passed (Any 10)',items:['Amritsari Paneer Tikka','Malai Soya Chaap','Dahi ke Sholay','Cocktail Samosa','Chilly Paneer','Paneer Papdi','Corn Kebab','Cottage Cheese Chilli','Vegetable Manchurian','Honey Chilli Crispy Potatoes','Cheese Balls','Cigar Rolls']},
 {name:'Salad Station',items:['Fresh Garden Green Salad','Kandhari Sprouted Moong Chaat','Pasta Salad','Russian Salad','Waldorf Salad','Coleslaw Salad','Achar','Papad','Chutney']},
 {name:'Main Course Indian (Any 10)',items:['Paneer Lababdar','Malai Kofta','Dum Aloo Banarsi','Kadahi Paneer','Dal Makhani','Dal Tadka','Bhindi Do Pyaza','Paneer Tikka Butter Masala','Mix Vegetable','Navratan Korma','Soya Chaap Masala','Palak Corn','Mutter Mushroom','Veg Kofta Curry']},
 {name:'International & Oriental',items:['Vegetable Manchurian','Cottage Cheese Schezwan','Mix Veggies Hot Garlic','Hakka Noodles','Chilli Garlic Rice']},
 {name:'Live Stations',items:['Desi Rasoi (Live Tawa)','Pasta Station — Penne/Spaghetti/Fusilli','Pizza Station — Margherita/Napolitana']},
 {name:'Desserts Indian',items:['Rasmalai','Jalebi with Rabri','Garam Gulab Jamun','Gulab Kheer','Moong Dal Halwa','Tilley Wali Kulfi']},
 {name:'Desserts Western',items:['Pastries Assortment','Vanilla & Strawberry Ice Creams']},
 ]},
 breakfast: { label:' Breakfast', rate:BASE_RATES.breakfast_standalone,
 categories:[
 {name:'Day 1 Breakfast',items:['Puri Bhaji','Poha','Veg Sandwich','Veg Cutlet','Butter Toast','Muffins','Cornflakes with Milk','Juice','Cut Fruits','Daliya','Tea & Coffee']},
 {name:'Day 2 Breakfast',items:['Idli Vada Sambhar','Shewai','Aloo Bonda','Butter Toast','Cornflakes with Milk','Juice','Cut Fruits','Tea & Coffee','Dahi Paratha','Suji ka Halwa']},
 {name:'Day 3 Breakfast',items:['Idli Vada Sambhar','Puri Bhaji','Cornflakes with Milk','Juice','Cut Fruits','Tea & Coffee','Dahi Paratha']},
 ]},
};

const MEAL_TYPES = Object.keys(MENU);
const inp = { width:'100%', padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none' };
const sel = { ...inp, cursor:'pointer' };

// ── FOOD MODAL ────────────────────────────────────────────────────────────────
function FoodModal({ mealType, selected, onSave, onClose }) {
 const menu = MENU[mealType];
 const [selItems, setSelItems] = useState(selected || []);
 const toggle = item => setSelItems(p => p.includes(item) ? p.filter(x=>x!==item) : [...p,item]);
 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.88)', zIndex:2000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding:16, overflowY:'auto' }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth:700, marginTop:20, marginBottom:20 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 22px', borderBottom:'1px solid rgba(255,255,255,.08)', background:'linear-gradient(135deg,#192D1F,#1A2E1A)', borderRadius:'16px 16px 0 0' }}>
 <div>
 <div style={{ fontWeight:800, fontSize:15, color:'#fff' }}>{menu.label} — Food Selection</div>
 <div style={{ fontSize:11, color:'rgba(255,255,255,.4)', marginTop:2 }}>{selItems.length} items selected · {inr(menu.rate)}/pax</div>
 </div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:20, cursor:'pointer' }}></button>
 </div>
 <div style={{ padding:22, maxHeight:'65vh', overflowY:'auto' }}>
 {menu.categories.map((cat,i) => (
 <div key={i} style={{ marginBottom:16 }}>
 <div style={{ fontSize:12, fontWeight:700, color:C.amber, marginBottom:8, textTransform:'uppercase', letterSpacing:'.06em' }}>{cat.name}</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:5 }}>
 {cat.items.map((item,j) => {
 const isSel = selItems.includes(item);
 return (
 <div key={j} onClick={() => toggle(item)}
 style={{ padding:'7px 10px', background:isSel?`${C.accent}18`:C.surface2, border:`1px solid ${isSel?C.accent:C.border}`, borderRadius:7, cursor:'pointer', display:'flex', alignItems:'center', gap:7 }}>
 <div style={{ width:15, height:15, borderRadius:4, background:isSel?C.accent:'transparent', border:`2px solid ${isSel?C.accent:C.border2}`, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, color:'#fff' }}>
 {isSel?'':''}
 </div>
 <span style={{ fontSize:12, color:isSel?C.text:C.text2 }}>{item}</span>
 </div>
 );
 })}
 </div>
 </div>
 ))}
 </div>
 <div style={{ display:'flex', justifyContent:'space-between', padding:'14px 22px', borderTop:'1px solid rgba(255,255,255,.08)', alignItems:'center' }}>
 <div style={{ fontSize:13, color:C.text2 }}>{selItems.length} items selected</div>
 <div style={{ display:'flex', gap:8 }}>
 <button onClick={onClose} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={() => { onSave(selItems); onClose(); }} style={{ padding:'9px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Save Selection</button>
 </div>
 </div>
 </div>
 </div>
 );
}

// ── DAY PLANNER ───────────────────────────────────────────────────────────────
function DayPlanner({ dayNum, data, onChange, onRemove, canRemove }) {
 const [foodModal, setFoodModal] = useState(null);
 const meals = data.meals || {};
 const toggleMeal = mealType => {
 if (meals[mealType]) { const m={...meals}; delete m[mealType]; onChange({...data,meals:m}); }
 else onChange({...data, meals:{...meals,[mealType]:{pax:data.pax||150,food_items:[]}}});
 };
 const updateMealPax = (mealType, pax) => onChange({...data, meals:{...meals,[mealType]:{...meals[mealType],pax:parseInt(pax)||1}}});
 const updateMealFood = (mealType, items) => onChange({...data, meals:{...meals,[mealType]:{...meals[mealType],food_items:items}}});

 return (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, marginBottom:16, overflow:'hidden' }}>
 <div style={{ padding:'12px 18px', background:'linear-gradient(135deg,#192D1F,#1E3520)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div style={{ fontWeight:800, fontSize:15, color:'#fff' }}> Day {dayNum}</div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <label style={{ fontSize:12, color:'rgba(255,255,255,.6)' }}>Default Pax:</label>
 <input type="number" min={1} value={data.pax||150} onChange={e=>onChange({...data,pax:parseInt(e.target.value)||1})}
 style={{ ...inp, width:80, padding:'4px 8px', fontSize:13 }} />
 {canRemove && (
 <button onClick={onRemove} style={{ padding:'4px 10px', background:'rgba(224,80,80,.2)', border:'1px solid rgba(224,80,80,.4)', borderRadius:6, color:C.red, cursor:'pointer', fontSize:12 }}> Remove</button>
 )}
 </div>
 </div>
 <div style={{ padding:14 }}>
 <div style={{ fontSize:11, color:C.text3, marginBottom:10, textTransform:'uppercase', letterSpacing:'.06em', fontWeight:600 }}>Select Meals</div>
 <div style={{ display:'grid', gap:8 }}>
 {MEAL_TYPES.map(mt => {
 const menu = MENU[mt];
 const mealData = meals[mt];
 const isSel = !!mealData;
 return (
 <div key={mt} style={{ background:isSel?`${C.accent}10`:C.surface2, border:`1px solid ${isSel?C.accent:C.border}`, borderRadius:10, padding:10 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:isSel?8:0 }}>
 <button onClick={()=>toggleMeal(mt)}
 style={{ width:20, height:20, borderRadius:5, background:isSel?C.accent:'transparent', border:`2px solid ${isSel?C.accent:C.border2}`, cursor:'pointer', color:'#fff', fontSize:10, flexShrink:0 }}>
 {isSel?'':''}
 </button>
 <div style={{ flex:1 }}>
 <span style={{ fontSize:13, fontWeight:600, color:C.text }}>{menu.label}</span>
 {menu.rate>0 && <span style={{ fontSize:11, color:C.accent, marginLeft:8 }}>{inr(menu.rate)}/pax</span>}
 </div>
 {isSel && menu.rate>0 && (
 <div style={{ fontSize:13, fontWeight:700, color:C.accent }}>{inr(menu.rate*(mealData.pax||data.pax||150))}</div>
 )}
 </div>
 {isSel && (
 <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', paddingLeft:30 }}>
 <div style={{ display:'flex', alignItems:'center', gap:6 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Pax:</label>
 <input type="number" min={1} value={mealData.pax||data.pax||150} onChange={e=>updateMealPax(mt,e.target.value)}
 style={{ ...inp, width:75, padding:'4px 8px', fontSize:12 }} />
 </div>
 <button onClick={()=>setFoodModal(mt)}
 style={{ padding:'4px 12px', background:mealData.food_items?.length>0?`${C.accent}20`:'rgba(255,255,255,.06)', border:`1px solid ${mealData.food_items?.length>0?C.accent:C.border2}`, borderRadius:6, color:mealData.food_items?.length>0?C.accent:C.text2, cursor:'pointer', fontSize:11, fontWeight:600 }}>
 {mealData.food_items?.length>0?`${mealData.food_items.length} items`:'Select Food Items'}
 </button>
 {mealData.food_items?.length>0 && (
 <div style={{ fontSize:11, color:C.text3 }}>{mealData.food_items.slice(0,3).join(', ')}{mealData.food_items.length>3?` +${mealData.food_items.length-3} more`:''}</div>
 )}
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 {foodModal && <FoodModal mealType={foodModal} selected={meals[foodModal]?.food_items||[]} onSave={items=>updateMealFood(foodModal,items)} onClose={()=>setFoodModal(null)} />}
 </div>
 );
}

// ── MAIN FORM ─────────────────────────────────────────────────────────────────
export default function WeddingBooking({ onClose, onSave, bookingToEdit }) {
 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const roleKey = currentUser?.roleKey || '';
 const isSuperAdmin = roleKey === 'SUPER_ADMIN';
 const isSales = roleKey === 'SALES';
 const { rates: pricingRates, getRoomRate } = usePricing();
 const isSalesDirector = currentUser?.name === 'Sonam Vashisth' || isSuperAdmin;
 const maxDiscount = isSuperAdmin ? 100 : isSalesDirector ? 12 : 5;
 const isEdit = !!bookingToEdit;

 const [step, setStep] = useState(1);
 const [saving, setSaving] = useState(false);
 const [error, setError] = useState('');

 // Guest
 const [guestName, setGuestName] = useState(bookingToEdit?.guest_name || '');
 const [guestPhone, setGuestPhone] = useState(bookingToEdit?.guest_phone || '');
 const [guestEmail, setGuestEmail] = useState(bookingToEdit?.guest_email || '');
 const [company, setCompany] = useState('');
 const [gstNum, setGstNum] = useState('');

 // Event
 const [checkIn, setCheckIn] = useState(bookingToEdit?.start_date?.slice(0,10) || '');
 const [checkOut, setCheckOut] = useState(bookingToEdit?.end_date?.slice(0,10) || '');
 const [rooms, setRooms] = useState(42);
 const [extraPersons, setExtraPersons] = useState(66);
 const [salesperson, setSalesperson] = useState(bookingToEdit?.salesperson || currentUser?.name || '');
 const [source, setSource] = useState(bookingToEdit?.source || 'Direct');
 const [notes, setNotes] = useState('');

 // Parse existing booking data on edit
 React.useEffect(() => {
 if (!bookingToEdit) return;
 try {
 const raw = bookingToEdit.notes || '';
 const jsonMatch = raw.match(/<<<WEDDING_DATA:(.*?)>>>/s);
 if (jsonMatch) {
 const d = JSON.parse(jsonMatch[1]);
 if (d.days) setDays(d.days);
 if (d.rooms !== undefined) setRooms(d.rooms);
 if (d.extraPersons !== undefined) setExtraPersons(d.extraPersons);
 if (d.venueIncluded !== undefined) setVenueIncluded(d.venueIncluded);
 if (d.venueRate !== undefined) setVenueRate(d.venueRate);
 if (d.checkoutBreakfast !== undefined) setCheckoutBreakfast(d.checkoutBreakfast);
 if (d.checkoutBreakfastPax !== undefined) setCheckoutBreakfastPax(d.checkoutBreakfastPax);
 if (d.addons) setAddons(d.addons);
 if (d.discountPct !== undefined) setDiscountPct(d.discountPct);
 if (d.advance !== undefined) setAdvance(d.advance);
 if (d.manualTotal) { setManualTotal(d.manualTotal); setUseManualTotal(true); }
 if (d.company) setCompany(d.company);
 if (d.gstNum) setGstNum(d.gstNum);
 if (d.notes) setNotes(d.notes);
 }
 } catch(e) {}
 }, []);

 // Venue
 const [venueIncluded, setVenueIncluded] = useState(true);
 const [venueRate, setVenueRate] = useState(BASE_RATES.venue_rent);

 // Checkout breakfast
 const [checkoutBreakfast, setCheckoutBreakfast] = useState(false);
 const [checkoutBreakfastPax, setCheckoutBreakfastPax] = useState(150);

 // Days
 const [days, setDays] = useState([
 { id:1, pax:150, meals:{} },
 { id:2, pax:150, meals:{} },
 ]);

 // Add-ons
 const [addons, setAddons] = useState(
 ADDON_LIST.reduce((acc, a) => ({ ...acc, [a.id]: { enabled: false, price: '', qty: 1, note: '' } }), {})
 );

 const updateAddon = (id, field, value) => setAddons(p => ({ ...p, [id]: { ...p[id], [field]: value } }));

 const nights = (() => {
 if (!checkIn || !checkOut) return days.length;
 return Math.max(1, Math.ceil((new Date(checkOut)-new Date(checkIn))/86400000));
 })();

 const calcBreakdown = () => {
 const bd = [];
 let subtotal = 0;
 if (rooms > 0) { const a=BASE_RATES.room_with_breakfast*rooms*nights; bd.push({label:`Room with Breakfast × ${rooms} × ${nights} night(s)`,amount:a}); subtotal+=a; }
 if (extraPersons > 0) { const a=BASE_RATES.extra_person*extraPersons*nights; bd.push({label:`Extra Person × ${extraPersons} × ${nights} night(s)`,amount:a}); subtotal+=a; }
 days.forEach((day,idx) => {
 Object.entries(day.meals||{}).forEach(([mt,md]) => {
 const menu=MENU[mt]; if(!menu||menu.rate===0) return;
 const pax=md.pax||day.pax||150;
 const a=menu.rate*pax;
 const food=md.food_items?.length>0?` (${md.food_items.length} items)`:'';
 bd.push({label:`Day ${idx+1} ${menu.label} × ${pax} pax${food}`,amount:a});
 subtotal+=a;
 });
 });
 if (checkoutBreakfast) { const a=BASE_RATES.breakfast_standalone*checkoutBreakfastPax; bd.push({label:`Checkout Breakfast × ${checkoutBreakfastPax} pax`,amount:a}); subtotal+=a; }
 if (venueIncluded) { bd.push({label:'Venue Rent (Flat)',amount:venueRate}); subtotal+=venueRate; }
 ADDON_LIST.forEach(addon => {
 const ad = addons[addon.id];
 if (ad?.enabled && ad?.price) {
 const amt = parseFloat(ad.price) * (parseInt(ad.qty)||1);
 bd.push({label:`${addon.name}${ad.qty>1?` × ${ad.qty}`:''}`,amount:amt});
 subtotal+=amt;
 }
 });
 return { bd, subtotal };
 };

 const [discountPct, setDiscountPct] = useState(0);
 const [manualTotal, setManualTotal] = useState('');
 const [useManualTotal, setUseManualTotal] = useState(false);
 const [advance, setAdvance] = useState(0);

 const { bd: breakdown, subtotal } = calcBreakdown();
 const discAmt = Math.round(subtotal * discountPct / 100);
 const calcTotal = subtotal - discAmt;
 const finalTotal = useManualTotal && manualTotal ? parseFloat(manualTotal) : calcTotal;
 const approvalRequired = discountPct > maxDiscount;

 const enabledAddons = ADDON_LIST.filter(a => addons[a.id]?.enabled);

 const handleSave = async () => {
 if (!guestName.trim()) { setError('Enter client/family name'); return; }
 if (!checkIn) { setError('Select check-in date'); return; }
 if (approvalRequired) { setError(`Discount above ${maxDiscount}% requires Super Admin approval`); return; }
 setSaving(true); setError('');
 try {
 const bdText = breakdown.map(b=>`${b.label}: ${inr(b.amount)}`).join('\n');
 const addonText = enabledAddons.map(a=>`${a.name}: ${inr(parseFloat(addons[a.id].price||0)*(addons[a.id].qty||1))}`).join('\n');
 const method = isEdit ? 'PUT' : 'POST';
 const url = isEdit ? `${API}/bookings/${bookingToEdit.id}` : `${API}/bookings`;
 const res = await fetch(url, {
 method, headers:{'Content-Type':'application/json'},
 body: JSON.stringify({
 guest_name:guestName, guest_phone:guestPhone, guest_email:guestEmail,
 booking_type:' Event / Wedding',
 start_date:checkIn, end_date:checkOut||checkIn,
 pax_count:days[0]?.pax||150,
 booking_status:'Confirmed',
 total_amount:finalTotal, advance_paid:advance, balance_amount:finalTotal-advance,
 salesperson, source, discount_pct:discountPct,
 notes:`<<<WEDDING_DATA:${JSON.stringify({days,rooms,extraPersons,venueIncluded,venueRate,checkoutBreakfast,checkoutBreakfastPax,addons,discountPct,advance,manualTotal,company,gstNum,notes})}>>>
Wedding Booking — ${days.length} Function Day(s)\nRooms: ${rooms} | Extra Persons: ${extraPersons}\n\nCOST BREAKDOWN:\n${bdText}${addonText?'\n\nADD-ONS:\n'+addonText:''}\n\nSubtotal: ${inr(subtotal)}\nDiscount ${discountPct}%: -${inr(discAmt)}\nFINAL TOTAL: ${inr(finalTotal)}\n\n${notes}`,
 }),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error||'Failed');
 onSave(); onClose();
 } catch(err) { setError(err.message); }
 finally { setSaving(false); }
 };

 const { subtotal: runST } = calcBreakdown();
 const runTotal = runST - Math.round(runST * discountPct / 100);

 const STEPS = [
 {n:1, l:'1. Client & Event'},
 {n:2, l:'2. Days & Meals'},
 {n:3, l:'3. Add-ons & Décor'},
 {n:4, l:'4. Rooms & Pricing'},
 ];

 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.78)', zIndex:1000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding:16, overflowY:'auto' }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth:920, marginTop:20, marginBottom:20 }}>

 {/* Header */}
 <div style={{ padding:'16px 24px', background:'linear-gradient(135deg,#1A0A2E,#2A1040)', borderRadius:'16px 16px 0 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div>
 <div style={{ fontWeight:900, fontSize:17, color:'#fff' }}> {isEdit?'Edit':'New'} Wedding / Event Booking</div>
 <div style={{ fontSize:12, color:'rgba(255,255,255,.5)', marginTop:2 }}>Multi-day function with food selection & add-ons</div>
 </div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <div style={{ fontSize:16, fontWeight:800, color:C.accent }}>{inr(runTotal)}</div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:20, cursor:'pointer' }}></button>
 </div>
 </div>

 {/* Step tabs */}
 <div style={{ display:'flex', gap:0, padding:'0 24px', borderBottom:'1px solid rgba(255,255,255,.08)', flexWrap:'wrap' }}>
 {STEPS.map(s=>(
 <button key={s.n} onClick={()=>s.n<=step?setStep(s.n):null}
 style={{ padding:'11px 18px', background:'transparent', border:'none', borderBottom:`2px solid ${step===s.n?C.accent:'transparent'}`, color:step===s.n?C.accent:step>s.n?C.text2:C.text3, cursor:'pointer', fontSize:13, fontWeight:600, whiteSpace:'nowrap' }}>
 {s.l}
 </button>
 ))}
 </div>

 <div style={{ padding:24 }}>
 {error && <div style={{ padding:'10px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:8, color:C.red, fontSize:13, marginBottom:16 }}>{error}</div>}

 {/* ── STEP 1 ── */}
 {step===1 && (
 <div>
 <AvailabilityCalendar onDateSelect={date=>setCheckIn(date)} selectedDate={checkIn} />
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Client Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:20 }}>
 <div style={{ gridColumn:'span 2' }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Client / Family Name *</label>
 <input style={inp} type="text" value={guestName} onChange={e=>setGuestName(e.target.value)} placeholder="e.g. Sharma Family Wedding — Rahul & Priya" />
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Phone</label><input style={inp} type="text" value={guestPhone} onChange={e=>setGuestPhone(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Email</label><input style={inp} type="email" value={guestEmail} onChange={e=>setGuestEmail(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Company / Travel Agent</label><input style={inp} type="text" value={company} onChange={e=>setCompany(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>GST Number</label><input style={inp} type="text" value={gstNum} onChange={e=>setGstNum(e.target.value)} /></div>
 </div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Event Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Check-in Date *</label><input style={inp} type="date" value={checkIn} onChange={e=>setCheckIn(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Check-out Date</label><input style={inp} type="date" value={checkOut} onChange={e=>setCheckOut(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Source</label>
 <select style={sel} value={source} onChange={e=>setSource(e.target.value)}>
 {['Direct','Travel Agent','Corporate','Referral','Website','WhatsApp','OTA'].map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Salesperson</label><input style={inp} type="text" value={salesperson} onChange={e=>!isSales&&setSalesperson(e.target.value)} readOnly={isSales} style={{...inp, opacity:isSales?0.7:1}} /></div>
 </div>
 </div>
 )}

 {/* ── STEP 2: Days & Meals ── */}
 {step===2 && (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}>{days.length} Function Day{days.length>1?'s':''}</div>
 <button onClick={()=>setDays(p=>[...p,{id:Date.now(),pax:150,meals:{}}])}
 style={{ padding:'8px 16px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>+ Add Day</button>
 </div>
 {days.map((day,idx)=>(
 <DayPlanner key={day.id} dayNum={idx+1} data={day}
 onChange={data=>setDays(p=>p.map(d=>d.id===day.id?{...data,id:day.id}:d))}
 onRemove={()=>setDays(p=>p.filter(d=>d.id!==day.id))}
 canRemove={days.length>1} />
 ))}
 {/* Checkout Breakfast */}
 <div style={{ background:C.surface2, borderRadius:12, padding:14, marginTop:8 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:checkoutBreakfast?12:0 }}>
 <button onClick={()=>setCheckoutBreakfast(p=>!p)}
 style={{ width:20, height:20, borderRadius:5, background:checkoutBreakfast?C.accent:'transparent', border:`2px solid ${checkoutBreakfast?C.accent:C.border2}`, cursor:'pointer', color:'#fff', fontSize:10, flexShrink:0 }}>
 {checkoutBreakfast?'':''}
 </button>
 <div>
 <div style={{ fontSize:13, fontWeight:600, color:C.text }}> Checkout Day Breakfast (Optional)</div>
 <div style={{ fontSize:11, color:C.text3 }}>Guests checking out after breakfast on last day · {inr(BASE_RATES.breakfast_standalone)}/pax</div>
 </div>
 {checkoutBreakfast && <div style={{ fontSize:13, fontWeight:700, color:C.accent, marginLeft:'auto' }}>{inr(BASE_RATES.breakfast_standalone*checkoutBreakfastPax)}</div>}
 </div>
 {checkoutBreakfast && (
 <div style={{ display:'flex', alignItems:'center', gap:10, paddingLeft:30 }}>
 <label style={{ fontSize:12, color:C.text2 }}>Pax for Breakfast:</label>
 <input type="number" min={1} value={checkoutBreakfastPax} onChange={e=>setCheckoutBreakfastPax(parseInt(e.target.value)||1)}
 style={{ ...inp, width:100, padding:'6px 10px', fontSize:13 }} />
 </div>
 )}
 </div>
 </div>
 )}

 {/* ── STEP 3: Add-ons ── */}
 {step===3 && (
 <div>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:6 }}> Add-ons, Décor & Services</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:16 }}>Enter the negotiated price for each add-on. Leave disabled if not included.</div>
 <div style={{ display:'grid', gap:8 }}>
 {ADDON_LIST.map(addon => {
 const ad = addons[addon.id];
 const isEnabled = ad?.enabled;
 const total = isEnabled && ad?.price ? parseFloat(ad.price)*(parseInt(ad.qty)||1) : 0;
 return (
 <div key={addon.id} style={{ background:isEnabled?`${C.accent}10`:C.surface2, border:`1px solid ${isEnabled?C.accent:C.border}`, borderRadius:10, padding:12 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10 }}>
 <button onClick={()=>updateAddon(addon.id,'enabled',!isEnabled)}
 style={{ width:20, height:20, borderRadius:5, background:isEnabled?C.accent:'transparent', border:`2px solid ${isEnabled?C.accent:C.border2}`, cursor:'pointer', color:'#fff', fontSize:10, flexShrink:0 }}>
 {isEnabled?'':''}
 </button>
 <div style={{ fontSize:18, flexShrink:0 }}>{addon.icon}</div>
 <div style={{ flex:1 }}>
 <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{addon.name}</div>
 <div style={{ fontSize:11, color:C.text3 }}>{addon.unit}</div>
 </div>
 {isEnabled && (
 <>
 <div style={{ display:'flex', alignItems:'center', gap:6 }}>
 <span style={{ fontSize:11, color:C.text3 }}>₹</span>
 <input type="number" min={0} value={ad.price} onChange={e=>updateAddon(addon.id,'price',e.target.value)}
 placeholder="Price" style={{ ...inp, width:110, padding:'5px 8px', fontSize:13 }} />
 </div>
 {addon.unit.includes('unit')||addon.unit.includes('set')||addon.unit.includes('day') ? (
 <div style={{ display:'flex', alignItems:'center', gap:6 }}>
 <span style={{ fontSize:11, color:C.text3 }}>Qty</span>
 <input type="number" min={1} value={ad.qty||1} onChange={e=>updateAddon(addon.id,'qty',e.target.value)}
 style={{ ...inp, width:60, padding:'5px 8px', fontSize:13 }} />
 </div>
 ) : null}
 {total > 0 && <div style={{ fontSize:13, fontWeight:700, color:C.accent, flexShrink:0 }}>{inr(total)}</div>}
 </>
 )}
 </div>
 {isEnabled && (
 <div style={{ paddingLeft:62, marginTop:6 }}>
 <input type="text" value={ad.note||''} onChange={e=>updateAddon(addon.id,'note',e.target.value)}
 placeholder="Note (optional — e.g. 5 gazebos at poolside)" style={{ ...inp, padding:'5px 10px', fontSize:12 }} />
 </div>
 )}
 </div>
 );
 })}
 </div>
 {enabledAddons.length > 0 && (
 <div style={{ marginTop:14, padding:'12px 16px', background:C.purpleBg, border:'1px solid rgba(128,96,192,.3)', borderRadius:8, fontSize:13, color:C.purple }}>
 {enabledAddons.length} add-on(s) selected · Add-on subtotal: <strong>{inr(ADDON_LIST.filter(a=>addons[a.id]?.enabled&&addons[a.id]?.price).reduce((s,a)=>s+parseFloat(addons[a.id].price||0)*(parseInt(addons[a.id].qty)||1),0))}</strong>
 </div>
 )}
 </div>
 )}

 {/* ── STEP 4: Rooms & Pricing ── */}
 {step===4 && (
 <div>
 {/* Rooms */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.accent, marginBottom:12 }}> Room Accommodation ({nights} night{nights>1?'s':''})</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Rooms with Breakfast</label>
 <input style={inp} type="number" min={0} value={rooms} onChange={e=>setRooms(parseInt(e.target.value)||0)} />
 <div style={{ fontSize:11, color:C.accent, marginTop:4 }}>{inr(BASE_RATES.room_with_breakfast)} × {rooms} × {nights} = {inr(BASE_RATES.room_with_breakfast*rooms*nights)}</div>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Extra Persons (sharing)</label>
 <input style={inp} type="number" min={0} value={extraPersons} onChange={e=>setExtraPersons(parseInt(e.target.value)||0)} />
 <div style={{ fontSize:11, color:C.accent, marginTop:4 }}>{inr(BASE_RATES.extra_person)} × {extraPersons} × {nights} = {inr(BASE_RATES.extra_person*extraPersons*nights)}</div>
 </div>
 </div>
 </div>

 {/* Venue */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:venueIncluded?12:0 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.accent }}> Venue Rent</div>
 <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
 <input type="checkbox" checked={venueIncluded} onChange={e=>setVenueIncluded(e.target.checked)} />
 <span style={{ fontSize:12, color:C.text2 }}>Include venue rent</span>
 </label>
 </div>
 {venueIncluded && <input style={inp} type="number" value={venueRate} onChange={e=>setVenueRate(parseFloat(e.target.value)||0)} />}
 </div>

 {/* Breakdown */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}> Full Cost Breakdown</div>
 <div style={{ maxHeight:240, overflowY:'auto' }}>
 {breakdown.map((b,i)=>(
 <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:13, padding:'6px 0', borderBottom:'1px solid rgba(255,255,255,.04)', color:C.text2 }}>
 <span>{b.label}</span><span style={{ fontWeight:600, color:C.text, flexShrink:0, marginLeft:10 }}>{inr(b.amount)}</span>
 </div>
 ))}
 </div>
 <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:10, marginTop:8 }}>
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}><span>Subtotal</span><span>{inr(subtotal)}</span></div>
 {discountPct>0 && <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, color:C.amber, marginBottom:4 }}><span>Discount ({discountPct}%)</span><span>- {inr(discAmt)}</span></div>}
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:20, fontWeight:900, color:C.accent, borderTop:`1px solid ${C.border}`, paddingTop:8, marginTop:4 }}>
 <span>Total (GST Extra)</span><span>{inr(useManualTotal&&manualTotal?parseFloat(manualTotal):calcTotal)}</span>
 </div>
 </div>
 </div>

 {/* Discount */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}>
 Discount <span style={{ fontSize:11, color:C.text3, fontWeight:400 }}>Your limit: {maxDiscount}% ({isSalesDirector?'Sales Director':isSuperAdmin?'Admin':'Sales Team'})</span>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Discount %</label>
 <input style={inp} type="number" min={0} max={isSuperAdmin?100:maxDiscount} value={discountPct} onChange={e=>setDiscountPct(parseFloat(e.target.value)||0)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Discount Amount</label>
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.amber, fontSize:14, fontWeight:700 }}>{inr(discAmt)}</div></div>
 </div>
 {approvalRequired && <div style={{ marginTop:10, padding:'10px 14px', background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:8, color:C.amber, fontSize:13 }}> Discount above {maxDiscount}% requires approval from Super Admin (Atul / Priyanka Vashisth).</div>}
 </div>

 {/* Manual Override */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:useManualTotal?12:0 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}> Manual Rate (Round-off)</div>
 <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
 <input type="checkbox" checked={useManualTotal} onChange={e=>setUseManualTotal(e.target.checked)} />
 <span style={{ fontSize:12, color:C.text2 }}>Override with manual total</span>
 </label>
 </div>
 {useManualTotal && (
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Final Amount (₹)</label>
 <input style={inp} type="number" value={manualTotal} onChange={e=>setManualTotal(e.target.value)} placeholder={`Calculated: ${inr(calcTotal)}`} />
 {manualTotal && <div style={{ fontSize:11, color:C.accent, marginTop:4 }}>Override: {inr(parseFloat(manualTotal))} vs Calculated: {inr(calcTotal)}</div>}
 </div>
 )}
 </div>

 {/* Advance */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}> Advance Payment</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Advance Paid (₹)</label>
 <input style={inp} type="number" min={0} value={advance} onChange={e=>setAdvance(parseFloat(e.target.value)||0)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Balance Due</label>
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.red, fontSize:14, fontWeight:700 }}>{inr(finalTotal-advance)}</div></div>
 </div>
 </div>

 {/* Notes */}
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Notes / Special Requirements</label>
 <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Special requirements, dietary preferences, room allocation, special décor notes..."
 style={{ ...inp, height:80, resize:'vertical' }} />
 </div>
 </div>
 )}
 </div>

 {/* Footer */}
 <div style={{ display:'flex', justifyContent:'space-between', padding:'16px 24px', borderTop:'1px solid rgba(255,255,255,.08)' }}>
 <div>{step>1 && <button onClick={()=>setStep(s=>s-1)} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>← Back</button>}</div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 {step===4 && <div style={{ fontSize:16, fontWeight:900, color:C.accent }}>{inr(finalTotal)}</div>}
 <button onClick={onClose} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>Cancel</button>
 {step<4
 ? <button onClick={()=>{
 if(step===1&&!guestName.trim()){setError('Enter client name');return;}
 if(step===1&&!checkIn){setError('Select check-in date');return;}
 setError('');setStep(s=>s+1);
 }} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>Next →</button>
 : <><button onClick={handleSave} disabled={saving||approvalRequired}
 style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700, opacity:(saving||approvalRequired)?.6:1 }}>
 {saving?'Saving…':isEdit?' Save Changes':' Confirm Booking'}
 </button>
 <button onClick={()=>{
   fetch('https://api.botanix.in/api/sessions/proposals', {
     method:'POST', headers:{'Content-Type':'application/json'},
     body:JSON.stringify({
       client_name: guestName||'Guest',
       client_phone: guestPhone||'',
       client_email: guestEmail||'',
       event_date: checkIn,
       event_end_date: checkOut||checkIn,
       pax_count: days[0]?.pax||150,
       venue: days[0]?.venue||'',
       salesperson: salesperson||'',
       total_amount: finalTotal||0,
       advance_required: Math.round((finalTotal||0)*0.5),
       valid_until: new Date(Date.now()+30*24*60*60*1000).toISOString().slice(0,10),
     })
   }).then(r=>r.json()).then(d=>{
     if(d.proposal_number) alert('Proposal '+d.proposal_number+' created! Go to Sales CRM -> Proposals to add functions and send.');
     else alert('Failed: '+(d.error||'Unknown'));
   }).catch(e=>alert('Error'));
 }} style={{padding:'10px 20px',background:'#153D4B',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,fontWeight:700,marginLeft:8}}>
   Generate Proposal
 </button></>
 }
 </div>
 </div>
 </div>
 </div>
 );
}
